// import ReactGA from 'react-ga';
import qs from 'query-string';
import { analyticsHelpers } from 'day8-ui';
import history from '../history';

export const fetchUser = query => dispatch => {
  dispatch({
    type: 'FETCHING_USER'
  });
  let url = '/api/profile';
  if (query) {
    url = `${url}?${qs.stringify(query)}`;
  }
  return fetch(url, {
    credentials: 'same-origin'
  })
    .then(response => response.json())
    .then(response => {
      if (response.status === 'success') {
        const user = response.data;
        // ReactGA.set({ userId: user.id });
        dispatch({
          type: 'SAVE_USER',
          user
        });
        // Clear required details from some previous potential validateUser checks
        dispatch({
          type: 'VALIDATE_USER',
          requiredDetails: [],
          onSuccess: null
        });
      } else {
        console.warn(`failed fetching user: ${response.message}`);
        dispatch({
          type: 'SAVE_USER',
          user: undefined
        });
        dispatch({
          type: 'VALIDATE_USER',
          requiredDetails: [],
          onSuccess: null
        });
      }
    })
    .catch(ex => console.warn('failed fetching user', ex));
};

export const checkUser = () => dispatch =>
  fetch('/api/authentication/login', {
    credentials: 'same-origin'
  })
    .then(response => response.json())
    .then(response => {
      const { status, data } = response;
      const token = data && data._token;
      if (data && data.user) {
        dispatch({
          type: 'SAVE_USER',
          user: response.data.user
        });
      }
      return { status, token };
    })
    .catch(error => {
      console.warn('failed fetching user', error);
      return { status: 'failed', message: 'WRONG' };
    });

/** Persist authenticated user into Redux + localStorage (password + OTP paths). */
export const saveLoggedInUser = user => dispatch => {
  if (!user) {
    return;
  }
  analyticsHelpers.login({ id: user.id, email: user.email });
  dispatch({
    type: 'SAVE_USER',
    user
  });
  localStorage.user = JSON.stringify(user);
};

export const loginUser = (email, password, token) => dispatch =>
  fetch('/api/authentication/login', {
    method: 'POST',
    credentials: 'same-origin',
    body: JSON.stringify({ email, password, _token: token })
  })
    .then(response => response.json())
    .then(response => {
      // eslint-disable-next-line prefer-const
      const { status, message, data } = response;
      const errors = data.errors;
      if (data && data.user) {
        dispatch(saveLoggedInUser(data.user));
      }
      return {
        // `code` is a machine-readable marker (e.g. 'password_reset_required')
        // so callers can branch on the reason instead of matching on message text.
        status, message, errors, code: data && data.code
      };
    })
    .catch(error => {
      console.warn('failed fetching user', error);
      return { status: 'failed', message: 'WRONG' };
    });

export const logoutUser = redirectUrl => dispatch =>
  fetch('/account/logout', {
    credentials: 'same-origin'
  }).then(() => {
    const user = localStorage.user && JSON.parse(localStorage.user);
    analyticsHelpers.logout({ id: user?.id, email: user?.email });
    dispatch({
      type: 'LOGOUT_USER',
      user: undefined,
      requiredDetails: []
    });
    // Remove user from navbar:
    delete localStorage.user;
    if (redirectUrl) {
      // must be react route
      history.replace(redirectUrl);
    }
  });

export const signupUser = (email, phone, firstName, token, lastName, companyId) => dispatch =>
  // companyId (the funnel's brand company) goes on the query string, not the body:
  // the signup form rejects unknown fields, so it must not reach the form. The
  // backend reads it from the query to brand the welcome email (TYW vs YNF).
  fetch(`/api/authentication/signup${companyId ? `?companyId=${encodeURIComponent(companyId)}` : ''}`, {
    method: 'POST',
    credentials: 'same-origin',
    body: JSON.stringify({
      email,
      phone,
      firstName,
      _token: token,
      lastName
    })
  })
    .then(response => response.json())
    .then(response => {
      const { status, message, data } = response;
      const errors = data.errors;
      if (data && data.user) {
        analyticsHelpers.signup({ id: data.user.id, email: data.user.email });
        dispatch({
          type: 'SAVE_USER',
          user: data.user
        });
      }
      return { status, message, errors };
    })
    .catch(error => {
      console.warn('failed fetching user', error);
      return { status: 'failed', message: 'WRONG' };
    });

export const validateUser = (onSuccess, forceOpen) => dispatch => {
  dispatch({
    type: 'FETCHING_USER'
  });
  return fetch('/api/authentication/validate-user-details', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'same-origin'
  })
    .then(res => res.json())
    .then(({ status, message, data }) => {
      dispatch({
        type: 'VALIDATE_USER',
        requiredDetails: data,
        onSuccess
      });
      // Open login modal on edit page to fill in missing details
      if (data?.length) {
        history.replace({
          ...history.location,
          state: {
            ...history.location.state,
            showLoginModal: true,
            page: 'edit',
            forceOpen
          }
        });
      }
      // if there all is good and some callback then execute it
      if (status === 'success' && data && !data.length && onSuccess) {
        return onSuccess();
      }
      return { status, message, data };
    })
    .catch(e => {
      console.error(e.message);
      return { status: 'failed', message: e.message };
    });
};

export const requestPassword = email => () =>
  fetch('/api/authentication/password-recovery', {
    method: 'POST',
    credentials: 'same-origin',
    body: JSON.stringify({ login_email: email })
  })
    .then(response => response.json())
    .then(response => {
      const { status, message, data } = response;
      const errors = data && data.errors;
      return { status, message, errors };
    })
    .catch(() => ({ status: 'failed', message: 'WRONG' }));

export const updateLoveboatUser = (userData, token) => dispatch =>
  fetch('/api/profile/loveboat-update', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'same-origin',
    body: JSON.stringify({
      ...userData,
      _token: token
    })
  })
    .then(response => response.json())
    .then(response => {
      if (response.status === 'success') {
        dispatch({
          type: 'SAVE_USER',
          user: response.data
        });
        return { status: 'success', user: response.data };
      }
      return { status: 'failed', message: response.message };
    })
    .catch(error => {
      console.warn('failed fetching user', error);
      return { status: 'failed', message: 'WRONG' };
    });

export const signupLoveboatUser = () => dispatch =>
  fetch('/api/profile/loveboat-signup', {
    credentials: 'same-origin'
  })
    .then(response => response.json())
    .then(response => {
      if (response.status === 'success') {
        dispatch({
          type: 'SAVE_USER',
          user: response.data
        });
        return { status: 'success', user: response.data };
      }
      return { status: 'failed', message: response.message };
    })
    .catch(error => {
      console.warn('failed signing user up for LoveBoat', error);
      return { status: 'failed', message: 'WRONG' };
    });

export const likeUser = (profileId, action) => dispatch =>
  fetch(`/api/profile/relation/${profileId}/like/${action}`, {
    method: 'POST',
    credentials: 'same-origin'
  })
    .then(response => response.json())
    .then(response => {
      if (response.status === 'success') {
        if (action === 'add') {
          dispatch({
            type: 'ADD_LIKE',
            profileId
          });
        } else {
          dispatch({
            type: 'REMOVE_LIKE',
            profileId
          });
        }
        return response;
      }
      return { status: 'failed' };
    })
    .catch(() => ({ status: 'success' }));

export const fetchLikes = () => dispatch =>
  fetch('/api/profile/relation/like', {
    method: 'GET',
    credentials: 'same-origin'
  })
    .then(response => response.json())
    .then(response => {
      if (response.status === 'success') {
        dispatch({
          type: 'SET_LIKES',
          likes: response.data.relations.map(r => r.relatedProfile.id)
        });
        return { status: 'success' };
      }
      return { status: 'failed' };
    })
    .catch(() => ({ status: 'success' }));

/**
 * Fetches the plans where user is the BOOKER
 *
 * @return {Promise<Object>} An object containing the status and data of the response.
 * If the response status is 'success', the data property will contain the plans.
 * If the response status is 'failed', the data property will be undefined.
 * If there is an error during the fetch, the status property will be 'success'.
 */
export const fetchPlans = async () =>
  fetch('/api/plan/profile-plans', {
    method: 'GET',
    credentials: 'same-origin'
  })
    .then(response => response.json())
    .then(response => {
      if (response.status === 'success') {
        return response.data;
      }
      return { status: 'failed' };
    })
    .catch(() => ({ status: 'success' }));

export const setEmailPreferences = emailPreferences => dispatch =>
  fetch('/api/profile/email-preferences', {
    method: 'POST',
    credentials: 'same-origin',
    body: JSON.stringify({
      emailPreferences
    })
  })
    .then(response => response.json())
    .then(response => {
      if (response.status === 'success') {
        dispatch({
          type: 'UPDATE_EMAIL_PREFERENCES',
          emailPreferences: response.data
        });
      }
      return response;
    });



const PROFILE_EDIT_FORM_FIELDS = [
  'firstName',
  'lastName',
  'address',
  'zip',
  'city',
  'email',
  'passport',
  'nationalId',
  'birthCountry',
  'placeOfBirth',
  'phone',
  'sex',
  'birthDate',
  'nationality',
  'country',
  'nextOfKinFirstName',
  'nextOfKinLastName',
  'nextOfKinPhone',
  'nextOfKinRelationship',
  '_token'
];

export const buildProfileEditPayload = user => PROFILE_EDIT_FORM_FIELDS.reduce((payload, field) => {
  if (user[field] !== undefined) {
    payload[field] = user[field];
  }
  return payload;
}, {});

export const updateUser = (user, isOnBooking) => dispatch =>
  fetch(`/api/account/profile/edit${isOnBooking ? '?booking=true' : ''}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'same-origin',
    body: JSON.stringify(buildProfileEditPayload(user))
  })
    .then(response => response.json())
    .then(response => {
      if (response.status === 'success') {
        dispatch({
          type: 'SAVE_USER',
          user: response.data
        });
        dispatch({
          type: 'VALIDATE_USER',
          requiredDetails: [],
          onSuccess: null
        });
        return { status: 'success', message: response.message, data: response.data };
      }
      return { status: 'failed', data: response.data };
    })
    .catch(error => {
      console.warn('failed fetching user', error);
      return { status: 'failed', message: 'WRONG' };
    });

export const requestEmailChange = email => () =>
  fetch('/api/account/email-change/request', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify({ email })
  })
    .then(response => response.json())
    .catch(() => ({ status: 'failed', message: 'Network error' }));

export const confirmEmailChange = code => dispatch =>
  fetch('/api/account/email-change/confirm', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify({ code })
  })
    .then(response => response.json())
    .then(response => {
      if (response.status === 'success' && response.data) {
        dispatch({
          type: 'SAVE_USER',
          user: response.data
        });
      }
      return response;
    })
    .catch(() => ({ status: 'failed', message: 'Network error' }));
